import React from 'react';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

// Importing images from assets/img/casestudy2/
import img1 from '../../assets/img/casestudy2/1.png';
import img2 from '../../assets/img/casestudy2/2.png';
import img3 from '../../assets/img/casestudy2/3.png';
import img4 from '../../assets/img/casestudy2/4.png';
import img5 from '../../assets/img/casestudy2/5.png';
import img6 from '../../assets/img/casestudy2/6.png';

const CaseStudy2Section3 = () => {
    const images = [img1, img2, img3, img4, img5, img6];

    return (
        <section className="cs2-content-section">
            <div className="cs2-container">
                {/* 3x2 Image Gallery */}
                <div className="cs2-gallery-grid">
                    {images.map((img, index) => (
                        <div key={index} className="cs2-gallery-item">
                            <img src={img.src || img} alt={`Case Study Detail ${index + 1}`} />
                        </div>
                    ))}
                </div>

                <div className="cs2-text-content">
                    {/* Project Overview */}
                    <div className="cs2-content-block">
                        <h2 className="cs2-heading">Project Overview</h2>
                        <p>
                            Archdraw Outsourcing has completed a project involving the conversion of a fast-track PDF to BIM Modeling project in 565 Pearl st. development that covers an area of 73,350 square feet built-up area. The client needed to have proper architectural BIM models that were based on the precise PDF submitted drawings that would be used in facilitating design processes, visualization, and documentation.
                        </p>
                        <p>
                            The main goal was to transform 2D architectural PDFs into a very detailed and coordinated 3D BIM model with Revit 2025, without any errors in precision and data accuracy and project standards, and within a very limited deadline to work with the 7 days.
                        </p>
                    </div>

                    {/* Challenges */}
                    <div className="cs2-content-block">
                        <h2 className="cs2-heading">Challenges</h2>
                        <p>
                            The biggest issue was the interpretation of architectural PDF drawings that were layered and converting them to an intelligent BIM model with the appropriate level, grid, wall assemblies, doors, windows, and room data. The need to keep dimensions on track and strict deadlines necessitated workflow management and coordination by the modeling team.
                        </p>
                        <p>
                            Also, the need to ensure that the BIM model was an accurate representation of the intended design without omission of architectural components was a major concern in the downstream applications like quantity take-offs, clash detection and construction documentation.
                        </p>
                    </div>

                    {/* Our Approach */}
                    <div className="cs2-content-block">
                        <h2 className="cs2-heading">Our Approach</h2>
                        <p>Archdraw Outsourcing had a team of 3 experienced BIM modelers to implement the project. Organized workflow was introduced:</p>
                        <ul className="cs2-list">
                            <li>Architectural information in PDF drawings extraction and analysis.</li>
                            <li>Creating project levels, grids, and base constraints in Revit 2025.</li>
                            <li>Detailed modeling of walls, floors, ceilings, doors, windows, and façade elements</li>
                            <li>Creation of sheets and views aligned with the original PDF documentation</li>
                            <li>Internal quality checks to ensure dimensional and design accuracy</li>
                        </ul>
                        <p>The team was well communicated and adhered to quality control measures to make sure that the model was to the client expectation.</p>
                    </div>

                    {/* Result */}
                    <div className="cs2-content-block">
                        <h2 className="cs2-heading">Result</h2>
                        <p>Archdraw Outsourcing was able to provide a complete coordination of architectural BIM model of the 73,350 sq. ft. building within a short period of 7 days. The model was:</p>
                        <ul className="cs2-list">
                            <li>True and consistent to given PDF drawings</li>
                            <li>Fully structured with proper families and parameters</li>
                            <li>Ready for coordination, visualization, and documentation</li>
                            <li>Developed as per Revit 2025 standards</li>
                        </ul>
                        <p>The client had been enjoying better project clarity, better design visualization, and sound BIM model to use in subsequent project phases.</p>
                    </div>

                    {/* Conclusion */}
                    <div className="cs2-content-block">
                        <h2 className="cs2-heading">Conclusion</h2>
                        <p>
                            The 565 Pearl St. project shows that Archdraw Outsourcing has a great potential of providing precise and rapid PDF to BIM Modeling services within a limited deadline. With the help of the developed workflows of Revit 2025 and the employment of a team of professional BIM specialists, we were able to assure accuracy, quality, and progress in time on this 73,350 sq. ft. architectural project.
                        </p>
                        <p>
                            We are a reliable partner in providing quality controlled and sound BIM Modeling Services in California due to our commitment to excellence and a well-organized quality control. We assist architects, contractors and developers to convert 2D drawings to intelligent 3D BIM models which enhance coordination, visualization, and the efficiency of the project at large.
                        </p>
                    </div>

                    <div className="cs2-footer">
                        <p className="cs2-rate-text">Rate this project:</p>
                        <Link href="/casestudy/casestudy" className="cs2-back-btn">
                            <ArrowLeft size={20} /> Back to Case Studies
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CaseStudy2Section3;
